var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCross = function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 100 100"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#Cross_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    x: 9,
    y: 9,
    fill: "#2C2C2C",
    rx: 40
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    d: "M56.07 56.071a1.38 1.38 0 0 1-1.01.428q-.58.001-1.01-.428L49 51.021l-5.051 5.05q-.429.43-1.011.43-.58 0-1.01-.43a1.39 1.39 0 0 1-.43-1.01q0-.58.43-1.01L46.98 49l-5.05-5.05a1.38 1.38 0 0 1-.43-1.012q0-.58.43-1.01.428-.428 1.01-.43.58.002 1.01.43l5.05 5.052 5.051-5.051q.43-.43 1.01-.43t1.01.43q.43.43.429 1.01 0 .58-.428 1.01L51.02 49l5.05 5.05q.43.43.43 1.01 0 .582-.43 1.011"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Cross_svg__a",
    width: 100,
    height: 100,
    x: 0,
    y: 0,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1410_11310"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1410_11310",
    result: "shape"
  })))));
};
export default SvgCross;